const { error, info } = global.console

export default { error, info }
